import { BreakpointObserver } from '@angular/cdk/layout';
import { Directive, Input, SimpleChanges, OnChanges, ElementRef, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';
import { isNullOrUndefined } from '@pineapplelab/util';
import { ImageSizeService } from 'src/app/service/image-size/image-size.service';
import { IImageConfig, IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';

@Directive({
	selector: '[dynamicImage]'
})
export class DynamicImageDirective implements OnChanges {

	@Input() baseImageSrc: string | SafeValue;
	@Input() cssClass: string;
	@Input() errorUrl: string = '';

	@Input() displayResolutions: number[] = undefined;
	@Input() isIcon: boolean = false;


	imageConfig: IImageConfig;

	breakpoint_xs = '(max-width: 450px)';
	breakpoint_sm = '(min-width: 451px) and (max-width: 800px)';
	breakpoint_md = '(min-width: 801px) and (max-width: 1024px)';
	breakpoint_lg = '(min-width: 1025px) and (max-width: 1200px)';
	breakpoint_xlg = '(min-width: 1201px)';

	resolutions: number[] = [];
	breakpointsMapping: { bkp: string, value: number }[];

	imageSrc: string;
	defaultSrc: string;
	bestSize: string = '';
	filename: string;
	extension: string;
	loadTry: number = 0;
	resolution: any = '';
    token: string = '';
	constructor(
		private image: ElementRef<HTMLImageElement>,
		private breakpointObserver: BreakpointObserver,
		private imageSizeService: ImageSizeService,
		private sanitizer: DomSanitizer
	) {
		image.nativeElement.onerror = (event) => this.errorImage(event);
	}

	ngOnChanges(changes: SimpleChanges): void {

		if (!isNullOrUndefined(changes['baseImageSrc']?.currentValue)) {

			this.sanitizerUrl();
			this.imageConfig = this.imageSizeService.getInstanceByUrl(this.baseImageSrc.toString());

			this.resolutions = this.displayResolutions || this.imageConfig.resolutions;
			const url = this.baseImageSrc.toString();
			this.filename = url.substring(0, url.lastIndexOf('.'));
			this.extension = url.substring(url.lastIndexOf('.'));
            this.token = this.extension.includes('?') ? this.extension.substring(this.extension.lastIndexOf('?')) : '';

			this.breakpointObserver.observe([
				this.breakpoint_xs,
				this.breakpoint_sm,
				this.breakpoint_md,
				this.breakpoint_lg,
				this.breakpoint_xlg,
			]).subscribe(screen => {
				if (this.isIcon) {
                    this.checkIcon();
				} else {
					const resLowToHeight = this.resolutions.sort((a, b) => a - b);
					this.breakpointsMapping =
						[
							{ bkp: this.breakpoint_xs, value: IMAGES_RESOLUTIONS.xs }, 		//	xs: 400,
							{ bkp: this.breakpoint_sm, value: IMAGES_RESOLUTIONS.sm },		// 	sm: 800,
							{ bkp: this.breakpoint_md, value: IMAGES_RESOLUTIONS.md },		// 	md: 1000,
							{ bkp: this.breakpoint_lg, value: IMAGES_RESOLUTIONS.lg },		// 	lg: 1200
							{ bkp: this.breakpoint_xlg, value: 1201 }
						].map(bkp => {

							let value = resLowToHeight.find(el => el >= bkp.value) || resLowToHeight[resLowToHeight.length - 1];
							return { ...bkp, value }

						})

					this.resolution = this.breakpointsMapping.find(({ bkp, value }) => screen.breakpoints[bkp])?.value || this.imageConfig.defaultResolution;
				}

				this.imageSrc = `${this.filename}_${this.resolution}.webp${this.token}`;
				this.image.nativeElement.src = this.imageSrc;
				this.loadTry = 0;

			});

		}
	}

	errorImage(event: any) {

		if (this.baseImageSrc) {
			this.sanitizerUrl();
			if (this.loadTry == 0)
				this.imageSrc = `${this.filename}_${this.resolution}${this.extension}&load=${Date.now()}`;
			if (this.loadTry == 1)
				this.imageSrc = `${this.filename}_${this.imageConfig.defaultResolution}${this.extension}&load=${Date.now()}`;
			if (this.loadTry == 2) {
				const sep = this.baseImageSrc.toString().includes('?') ? '&' : '?'
				this.imageSrc = this.baseImageSrc.toString() + `${sep}load=${Date.now()}`;
			}
			if (this.loadTry >= 3){
				this.imageSrc = this.errorUrl || '/assets/images/thumbnail.png'
            }
            this.loadTry++;
			this.image.nativeElement.src = this.imageSrc;
		}
	}

    checkIcon(){
        switch (true) {
            // ICONS
            case this.resolutions.some(x => x == IMAGES_RESOLUTIONS.is):
                this.resolution = IMAGES_RESOLUTIONS.is;
                break;

            case this.resolutions.some(x => x == IMAGES_RESOLUTIONS.im):
                this.resolution = IMAGES_RESOLUTIONS.im;
                break;

            case this.resolutions.some(x => x == IMAGES_RESOLUTIONS.il):
                this.resolution = IMAGES_RESOLUTIONS.il;
                break;

            case this.resolutions.some(x => x == IMAGES_RESOLUTIONS.xxs):
                this.resolution = IMAGES_RESOLUTIONS.xxs;
                break;

            case this.resolutions.some(x => x == IMAGES_RESOLUTIONS.xs):
                this.resolution = IMAGES_RESOLUTIONS.xs;
                break;

            default:
                this.resolution = this.imageConfig.defaultResolution;
                break;
        }

    }

	sanitizerUrl() {
		this.baseImageSrc = this.sanitizer.sanitize(SecurityContext.URL, this.baseImageSrc);
	}

}
